import type { DomainSchema, PdfCardDef } from '../types';
import { esc } from '../pdf-helpers';

export const LANGUAGES = {
  priority: true,
  cardTitle: '{name}',
  fields: {
    name: { type: 'text' },
    proficiency: { type: 'text' },
    addedAt: { type: 'date', hidden: true },
  },
  layout: [[{ field: 'proficiency' }]],
  editLayout: [[{ field: 'name' }], [{ field: 'proficiency' }]],
} satisfies DomainSchema;

const PROFICIENCY_MAP: Record<string, { label: string; pct: number }> = {
  NATIVE_OR_BILINGUAL: { label: 'Native', pct: 100 },
  FULL_PROFESSIONAL: { label: 'Full Professional', pct: 85 },
  PROFESSIONAL_WORKING: { label: 'Professional Working', pct: 65 },
  LIMITED_WORKING: { label: 'Limited Working', pct: 40 },
  ELEMENTARY: { label: 'Elementary', pct: 20 },
};

export const LanguagesPdfCard: PdfCardDef = {
  styles: `
    .lang-item { margin-bottom: 0.8rem; }
    .lang-item:last-child { margin-bottom: 0; }
    .lang-row { display: flex; justify-content: space-between; align-items: baseline; font-size: 12.5px; margin-bottom: 5px; }
    .lang-name { font-weight: 700; }
    .lang-level { color: var(--muted); font-size: 11px; font-weight: 300; }
    .lang-track { height: 4px; background: var(--line); border-radius: 2px; }
    .lang-fill  { height: 4px; background: var(--accent); border-radius: 2px; }
  `,
  render(records) {
    return records
      .map(r => {
        const p = PROFICIENCY_MAP[String(r['proficiency'])] ?? {
          label: esc(r['proficiency']) || '\u2014',
          pct: 30,
        };
        return `
          <div class="lang-item">
            <div class="lang-row">
              <span class="lang-name">${esc(r['name'])}</span>
              <span class="lang-level">${p.label}</span>
            </div>
            <div class="lang-track"><div class="lang-fill" style="width:${p.pct}%"></div></div>
          </div>`;
      })
      .join('');
  },
};
